<template>
  <form @submit.prevent="signIn({email, password})">
    <BaseInput
      v-model="email"
      :disabled="isSigningIn"
      type="email"
      label="email"
      size="lg"
      focused
      required
    />
    <BaseInputPassword
      v-model="password"
      :disabled="isSigningIn"
      label="password"
      size="lg"
      :focused="focus === 'password'"
    >
    </BaseInputPassword>
    <div class="flex justify-end">
      <BaseLink name="RequestPasswordReset">{{ forgotPassText }}</BaseLink>
    </div>
    <BaseSpacer />
    <BaseButton type="submit" class="w-full" size="lg" :loading="isSigningIn" action="sign_in" />
  </form>
</template>

<script>
import {BaseButton, BaseInput, BaseInputPassword, BaseLink, BaseSpacer} from '@/components/base'

export default {
  components: {
    BaseButton,
    BaseInput,
    BaseInputPassword,
    BaseLink,
    BaseSpacer,
  },
  data() {
    return {
      email: '',
      password: '',
      focus: '',
      isSigningIn: false,
    }
  },
  computed: {
    forgotPassText() {
      return this.$t('mygwf.views.Login.link.forgot_password')
    },
  },
  methods: {
    async signIn(credentials) {
      this.isSigningIn = true
      this.focus = ''
      try {
        await this.$store.dispatch('auth/logIn', credentials)
        this.$store.dispatch('app/notification', {type: 'success', group: 'auth', text: `sign_in`})
        this.$router.replace(this.$route.query.redirect || '/')
      } catch (error) {
        await this.$store.dispatch('app/notification', {
          type: 'error',
          group: 'auth',
          text: `sign_in`,
        })
        this.password = ''
        this.focus = 'password'
        this.isSigningIn = false
      }
    },
  },
}
</script>
